export const checkHEIC = (file: File) => {
  return (
    file.name.endsWith('.heic') ||
    file.name.endsWith('.heif') ||
    file.name.endsWith('.HEIC')
  )
}
